<template>
  <div class="etms-router-body">
    <div class="etms-router-search">
      <span class="etms-router-search-label fl">登录名：</span>
      <el-input size="mini" placeholder="用户登录名搜索" class="etms-router-search-element fl" v-model="search.LoginName"></el-input>
      <span class="etms-router-search-label fl">姓名：</span>
      <el-input size="mini" placeholder="用户姓名搜索" class="etms-router-search-element fl" v-model="search.Name"></el-input>
      <span class="etms-router-search-label fl">网点：</span>
      <el-select size="mini" placeholder="选择网点搜索" class="etms-router-search-element fl" filterable v-model="search.BranchesId">
        <el-option v-for="item in brancheslist" :key="item.id" :label="item.branchesName" :value="item.id"></el-option>
      </el-select>
      <span class="etms-router-search-label fl">部门：</span>
      <el-select size="mini" placeholder="选择部门搜索" class="etms-router-search-element fl" filterable v-model="search.DepartmentId">
        <el-option v-for="item in departments" :key="item.id" :label="item.departmentName" :value="item.id"></el-option>
      </el-select>
      <span class="etms-router-search-label fl">职位：</span>
      <el-select size="mini" placeholder="选择职位搜索" class="etms-router-search-element fl" filterable v-model="search.PositionId">
        <el-option v-for="item in positions" :key="item.id" :label="item.positionName" :value="item.id"></el-option>
      </el-select>
      <el-tooltip class="item" effect="dark" content="添加账号信息" placement="top">
        <el-button size="mini" @click="insetrAccount" class="etms-router-search-button fr" type="primary" icon="el-icon-plus"></el-button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="查询账号信息" placement="top">
        <el-button size="mini" @click="searchClick" class="etms-router-search-button fr" type="primary" icon="el-icon-search"></el-button>
      </el-tooltip>
      <div class="clear"></div>
    </div>
    <el-table :border="true" :data="accounts" height="90%" class="etms-router-list">
      <el-table-column type="index" label="序号" header-align="center" align="center"></el-table-column>
      <el-table-column label="姓名/登录名/昵称" prop="name" :formatter="formatterLogin" width="200px"></el-table-column>
      <el-table-column label="网点" prop="branchesId">
        <template slot-scope="scope">
          {{brancheslist.filter(b=>b.id === scope.row.branchesId)[0].branchesName}}
        </template>
      </el-table-column>
      <el-table-column label="所在部门" prop="departmentId" width="120px">
        <template slot-scope="scope">
          {{departments.filter(d=>d.id === scope.row.departmentId)[0].departmentName}}
        </template>
      </el-table-column>
      <el-table-column label="职位" prop="positionId" width="120px">
        <template slot-scope="scope">
          {{positions.filter(p=>p.id === scope.row.positionId)[0].positionName}}
        </template>
      </el-table-column>
      <el-table-column label="性别" prop="sex" width="100px">
        <template slot-scope="scope">
          {{constant.sexs.filter(s=>s.value === (scope.row.sex?'1':'0'))[0].label}}
        </template>
      </el-table-column>
      <el-table-column label="生日" prop="birthday" width="120px">
        <template slot-scope="scope">
          {{ scope.row.birthday !== null? scope.row.birthday.substring(0,10):''}}
        </template>
      </el-table-column>
      <el-table-column label="联系方式" prop="mobilePhone" width="200px">
        <template slot-scope="scope">
          手机：{{scope.row.mobilePhone}}<br />
          邮箱：{{scope.row.email}}
        </template>
      </el-table-column>
      <el-table-column label="地址" prop="address">
        <template slot-scope="scope">
          {{regionmodule.regionEachTrim(scope.row.regions.split(','),regionmodule.regions,0)}} {{scope.row.street}} {{scope.row.address}}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150px" align="center">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="账号权限设置" placement="top">
            <el-button size="mini" type="success" @click="handlePower(scope.$index,scope.row)" icon="el-icon-setting" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="修改此账号信息" placement="top">
            <el-button size="mini" type="primary" circle icon="el-icon-edit-outline" @click="handleEdit(scope.$index,scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除此账号" placement="top">
            <el-button size="mini" type="danger" circle icon="el-icon-delete" @click="handleDelete(scope.$index,scope.row)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="search.pageindex" :page-sizes="constant.pagesizes" :page-size="search.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="search.recordcount"></el-pagination>
    <el-dialog :title="dialogtitle" :visible.sync="dialogvisible" :modal-append-to-body="false" width="850px" center>
      <el-form :model="form" :ref="form.formname" :rules="rules" label-width="120px" class="el-form-half etms-dialog-form">
        <el-form-item prop="LoginName" label="登录名 ：">
          <el-input size="mini" v-model="form.LoginName" placeholder="账号创建后不可修改" class="el-width-200" :disabled="form.Id!==''"></el-input>
        </el-form-item>
        <el-form-item prop="LogioPassWord" label="登录密码 ：">
          <el-input size="mini" type="password" v-model="form.LoginPassword" placeholder="填写账号登录密码" class="el-width-200" :disabled="!editpassword"></el-input>
          <el-checkbox size="mini" v-model="editpassword" v-show="form.Id!==''">修改密码</el-checkbox>
        </el-form-item>
        <el-form-item prop="Name" label="姓名 ：">
          <el-input size="mini" v-model="form.Name" placeholder="填写账号拥有者姓名" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item prop="BranchesId" label="网点 ：">
          <el-select size="mini" placeholder="选择账号所属网点" v-model="form.BranchesId" filterable class="el-width-200">
            <el-option v-for="item in brancheslist" :key="item.id" :label="item.branchesName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="DepartmentId" label="部门 ：">
          <el-select size="mini" placeholder="选择账号所属部门" v-model="form.DepartmentId" filterable class="el-width-200">
            <el-option v-for="item in departments" :key="item.id" :label="item.departmentName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="PositionId" label="职位 ：">
          <el-select size="mini" placeholder="选择账号所在职位" v-model="form.PositionId" filterable class="el-width-200">
            <el-option v-for="item in positions" :key="item.id" :label="item.positionName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="NickName" label="昵称 ：">
          <el-input size="mini" v-model="form.NickName" placeholder="填写账号使用者网名" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item prop="Sex" label="性别 ：">
          <el-select size="mini" placeholder="您的性别" v-model="form.Sex" filterable class="el-width-200">
            <el-option v-for="item in constant.sexs" :label="item.label" :value="item.value" :key="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="Birthday" label="生日 ：">
          <el-date-picker size="mini" v-model="form.Birthday" placeholder="请选择日期" type="date" class="el-width-200"></el-date-picker>
        </el-form-item>
        <el-form-item prop="Region" label="地区 ：">
          <el-cascader size="mini" v-model="form.Regions" :options="regionmodule.regions" placeholder="请选择所在省市区" filterable clearable class="el-width-200"></el-cascader>
        </el-form-item>
        <el-form-item prop="Street" label="街道 ：">
          <el-input size="mini" v-model="form.Street" placeholder="填写所在街道" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item prop="Address" label="地址 ：">
          <el-input size="mini" v-model="form.Address" placeholder="填写所在详细住址" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item prop="MobilePhone" label="手机号码 ：">
          <el-input size="mini" v-model="form.MobilePhone" placeholder="账号拥有者手机号码" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item prop="Email" label="邮箱 ：">
          <el-input size="mini" v-model="form.Email" placeholder="账号拥有者邮箱" class="el-width-200"></el-input>
        </el-form-item>
      </el-form>
      <div class="clear"></div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogvisible=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="dialogSave">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="power.dialogtitle" :visible.sync="power.dialogvisible" :modal-append-to-body="false" width="700px" center>
      <div style="width:100%; height:500px;overflow:auto;">
        <div v-for="item in power.menus.filter(m=>m.parentMenuId==='00000000-0000-0000-0000-000000000000')" :key="item.id">
          <i :class="(item.style === ''?'el-icon-minus':item.style)" style="cursor:pointer;" @click="powerShow(item.id)"></i>
          <el-checkbox v-model="item.checked" :label="item.menuName" @change="menuChange(item,[])"></el-checkbox>
          <div v-for="menu in power.menus.filter(m=>m.parentMenuId === item.id)" :key="menu.id" v-show="menu.show" style="padding-left:30px;">
            <i :class="(menu.style === ''?'el-icon-minus':menu.style)" style="cursor:pointer;" @click="powerShow(menu.id)"></i>
            <el-checkbox v-model="menu.checked" :label="menu.menuName" @change="menuChange(menu,[item])"></el-checkbox>
            <div v-for="child in power.menus.filter(m=>m.parentMenuId === menu.id)" :key="child.id" v-show="child.show" style="padding-left:30px;">
              <el-checkbox v-model="child.checked" :label="child.menuName" @change="menuChange(child,[menu,item])"></el-checkbox>
              <div style="padding-left:30px;">
                <el-checkbox v-for="fun in power.functions.filter(f=>f.menuId===child.id)" :key="fun.id" v-model="fun.checked" :label="fun.functionName" @change="functionChange(fun,[child,menu,item])"></el-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="power.dialogvisible=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="powerSaveClick">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data () {
    var loginNameValidate = (rule, value, callback) => {
      var self = this

      if (self.form.Id === '') {
        if (value === '') {
          callback(new Error('请填写登录名'))
        }
        if (value.length < 5 || value.length > 20) {
          callback(new Error('登录名长度为6-20个字符'))
        }
        this.$ajax.post(this.constant.openPaths.existsLoginName, { LoginName: this.form.LoginName }).then(res => {
          if (res.data.code === 200) {
            callback()
          } else {
            callback(new Error(res.data.msg))
          }
        }).catch(function (error) {
          self.$message.error(error)
        })
      }
      else { callback() }
    }
    var loginPasswordValidate = (rule, value, callback) => {
      if (this.form.id === '' || this.editpassword) {
        if (value === '') {
          callback(new Error('请填写登录密码'))
        }
        if (value < 5 || value > 20) {
          callback(new Error('长度在5到20个字符'))
        }
      }
    }
    return {
      userinfo: this.$cookies.get('userinfo'),
      dialogtitle: '',
      dialogvisible: false,
      editpassword: false,
      brancheslist: [],
      departments: [],
      positions: [],
      accounts: [],
      search: {
        pageindex: 1,
        pagesize: 100,
        recordcount: 0,
        LoginName: '',
        Name: '',
        BranchesId: '',
        DepartmentId: '',
        PositionId: ''
      },
      form: {
        formname: 'accountform',
        OptimisticLock: '',
        Id: '',
        LoginName: '',
        LoginPassword: '',
        NickName: '',
        BranchesId: '',
        DepartmentId: '',
        PositionId: '',
        Name: '',
        Sex: '',
        Birthday: '',
        Regions: [],
        Address: '',
        MobilePhone: '',
        Email: ''
      },
      power: {
        dialogtitle: '权限设置',
        dialogvisible: false,
        menus: [],
        functions: [],
        Id: ''
      },
      rules: {
        LoginName: [
          { validator: loginNameValidate, trigger: 'blur' }
        ],
        LoginPassword: [
          { validator: loginPasswordValidate, trigger: 'blur' }
        ],
        Name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { max: 50, message: '长度请控制在50个字符以内', trigger: 'blur' }
        ],
        NickName: [
          { required: true, message: '请输入昵称', trigger: 'blur' },
          { max: 50, message: '长度请控制在50个字符以内', trigger: 'blur' }
        ],
        Sex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        BranchesId: [
          { required: true, message: '请选择网点', trigger: 'change' }
        ],
        DepartmentId: [
          { required: true, message: '请选择部门', trigger: 'change' }
        ],
        PositionId: [
          { required: true, message: '请选择职位', trigger: 'change' }
        ],
        MobilePhone: [
          { required: true, message: '请填写手机号码', trigger: 'blur' }
        ],
        Email: [
          { required: true, message: '请填写邮箱', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.initBranches()
    this.initDepartments()
    this.initPositions()
    this.searchClick()
  },
  methods: {
    initBranches () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchBranchesAll, data).then(res => {
          if (res.data.code === 200) {
            this.brancheslist = res.data.result
          } else {
            self.$message.error(res.data.msg)
          }
        }).catch(error => { self.$message.error(error) })
      }
    },
    initDepartments () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchDepartmentAll, data).then(res => {
          if (res.data.code === 200) {
            this.departments = res.data.result
          } else {
            self.$message.error(res.data.msg)
          }
        }).catch(error => { self.$message.error(error) })
      }
    },
    initPositions () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchPositionAll, data).then(res => {
          if (res.data.code === 200) {
            this.positions = res.data.result
          } else {
            self.$message.error(res.data.msg)
          }
        }).catch(error => { self.$message.error(error) })
      }
    },
    searchClick () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          PageSize: this.search.pagesize,
          PageIndex: this.search.pageindex,
          LoginName: this.search.LoginName,
          Name: this.search.Name,
          BranchesId: this.search.BranchesId,
          DepartmentId: this.search.DepartmentId,
          PositionId: this.search.PositionId
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchUserPager, data).then(res => {
          if (res.data.code === 200) {
            var result = res.data.result
            self.search.recordcount = result.recordCount
            self.accounts = result.tList
          } else {
            self.$message.error(res.data.msg)
          }
        }).catch(error => {
          self.$message.error(error)
        })
      }
    },
    clearForm () {
      var form = this.form
      Object.keys(form).forEach(item => {
        if (item !== 'formname') {
          switch (typeof (form[item])) {
            case 'string':
              form[item] = ''
              break
            case 'number':
              form[item] = 0
              break
            case 'object':
              if (Array.isArray(form[item])) {
                form[item] = []
              } else { }
              break
          }
        }
      })
    },
    insetrAccount () {
      this.dialogtitle = '添加账号信息'
      this.clearForm()
      this.dialogvisible = true
      this.editpassword = true
    },
    formatterLogin (row, column, cellvalue) {
      return cellvalue + '/' + row.loginName + '/' + row.nickName
    },
    formatterContact (row, column, cellvalue) {
      return '手机号码：' + cellvalue + '邮箱：' + row.email
    },
    handleEdit (index, row) {
      this.dialogvisible = true
      this.dialogtitle = '编辑账号信息'
      this.editpassword = false
      this.form.Id = row.id
      this.form.OptimisticLock = row.optimisticLock
      this.form.LoginName = row.loginName
      this.form.Name = row.name
      this.form.NickName = row.nickName
      this.form.BranchesId = row.branchesId
      this.form.DepartmentId = row.departmentId
      this.form.PositionId = row.positionId
      this.form.Sex = row.sex ? '1' : '0'
      this.form.Birthday = row.birthday === null ? '' : row.birthday.substring(0, 10)
      this.form.Regions = row.regions.split(',')
      this.form.Street = row.street
      this.form.Address = row.address
      this.form.MobilePhone = row.mobilePhone
      this.form.Email = row.email
    },
    handleDelete (index, row) {
      var self = this
      var data = {
        UserId: this.userinfo.id,
        EnterpriseId: this.userinfo.enterpriseId,
        LoginToken: this.userinfo.loginToken,
        Id: row.id,
        OptimisticLock: row.optimisticLock
      }
      this.$confirm('此操作将永久删除该账号,删除后不可恢复,是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.$ajax.post(self.constant.openPaths.deleteUserModel, data).then(res => {
          if (res.data.code === 200) {
            self.$message({ message: res.data.msg, type: 'success' })
            self.accounts.splice(index, 1)
          } else {
            self.$message.error(res.data.code)
          }
        }).catch(error => {
          self.$message.error(error)
        })
      })

    },
    handleSizeChange (val) {
      this.search.pagesize = val
      searchClick()
    },
    handleCurrentChange (val) {
      this.search.pageindex = val
      searchClick()
    },
    dialogSave () {
      var data = {
        UserId: this.userinfo.id,
        EnterpriseId: this.userinfo.enterpriseId,
        LoginToken: this.userinfo.loginToken,
        Id: this.form.Id,
        OptimisticLock: this.form.OptimisticLock,
        LoginName: this.form.LoginName,
        LoginPassword: this.form.LoginPassword,
        Name: this.form.Name,
        BranchesId: this.form.BranchesId,
        DepartmentId: this.form.DepartmentId,
        PositionId: this.form.PositionId,
        NickName: this.form.NickName,
        Sex: this.form.Sex,
        Birthday: this.form.Birthday,
        Regions: this.form.Regions,
        Street: this.form.Street,
        Address: this.form.Address,
        MobilePhone: this.form.MobilePhone,
        Email: this.form.Email
      }
      var url = ''
      if (data.Id === '' && data.OptimisticLock === '') {
        url = this.constant.openPaths.insertUserModel
      }
      else {
        url = this.constant.openPaths.updateUserModel
      }

      var self = this

      this.$refs[this.form.formname].validate((valid) => {
        if (valid) {
          self.$ajax.post(url, data).then(res => {
            if (res.data.code === 200) {
              self.$message({ message: res.data.msg, type: 'success' })
              self.clearForm()
              self.searchClick()
              self.dialogvisible = false
            } else { self.$message.error(res.data.msg) }
          }).catch(error => {
            self.$message.error(error)
          })
        }
      })
    },
    handlePower (index, row) {
      this.power.Id = row.id
      this.power.dialogvisible = true
      this.power.menus = []
      this.power.functions = []
      this.getUserMenus()
      this.getUserFunctions()
    },
    getUserMenus () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          Id: this.power.Id
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.loadUserMenus, data).then(res => {
          if (res.data.code === 200) {
            self.power.menus = res.data.result
          }
          else {
            self.$message.error(res.data.msg)
          }
        }).catch(error => {
          self.$message.error(error)
        })
      }
    },
    getUserFunctions () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          Id: this.power.Id
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.loadUserFunctions, data).then(res => {
          if (res.data.code === 200) {
            self.power.functions = res.data.result
          }
          else {
            self.$message.error(res.data.msg)
          }
        }).catch(error => {
          self.$message.error(error)
        })
      }
    },
    powerShow (menuid) {
      var menu = this.power.menus.filter(m => m.id === menuid)[0]
      if (menu.style === '' || menu.style == 'el-icon-minus') {
        menu.style = 'el-icon-plus'
      } else {
        menu.style = 'el-icon-minus'
      }
      this.power.menus.filter(m => m.parentMenuId === menuid).forEach(item => {
        item.show = menu.style === 'el-icon-minus'
      })
    },
    menuChange (item, array) {
      if (item.checked) {
        array.forEach((menu, index) => {
          menu.checked = item.checked
        })
      } else {
        this.eachChildMenu(item.id, item.checked)
      }
    },
    functionChange (item, array) {
      if (item.checked) {
        array.forEach(menu => {
          menu.checked = item.checked
        })
      }
    },
    eachChildMenu (id, checked) {
      this.power.functions.filter(f => f.menuId === id).forEach(fun => {
        fun.checked = checked
      })
      this.power.menus.filter(m => m.parentMenuId === id).forEach(item => {
        item.checked = checked
        this.power.functions.filter(f => f.menuId === item.id).forEach(fun => {
          fun.checked = checked
        })
        this.eachChildMenu(item.id, checked)
      })
    },
    powerSaveClick () {
      var menuids = new Array()
      this.power.menus.filter(m => m.checked).forEach(item => {
        menuids.push(item.id)
      })
      var funids = new Array()
      this.power.functions.filter(f => f.checked).forEach(item => {
        funids.push(item.id)
      })

      var data = {
        UserId: this.userinfo.id,
        EnterpriseId: this.userinfo.enterpriseId,
        LoginToken: this.userinfo.loginToken,
        Id: this.power.Id,
        MenuIds: menuids,
        FunctionIds: funids
      }
      var self = this
      this.$ajax.post(this.constant.openPaths.settingUserPower, data).then(res => {
        if (res.data.code === 200) {
          self.$message({ message: res.data.msg, type: 'success' })
        } else {
          self.$message.error(res.data.msg)
        }
      }).catch(error => { self.$message.error(error) })
    }
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/components/etms/ems/account_manage.vue